import { Contact as Model } from 'model';
import { ManPage } from 'components/ManPage/ManPage';

export function Contact({ contact }: { contact: Model }): JSX.Element {
  return (
    <ManPage
      name="contact"
      manual="Reach Out"
      sections={[
        { heading: 'NAME', body: contact.title },
        { heading: 'DESCRIPTION', body: contact.contactMessage },
        {
          heading: 'EMAIL',
          body: <a href={'mailto:' + contact.email}>{contact.email}</a>
        },
        {
          heading: 'PGP KEY',
          body: (
            <>
              <a href={contact.pgpPublicKey} className="man-btn">
                download
              </a>
              {'\n\n'}
              {contact.pgpKey}
            </>
          )
        }
      ]}
    />
  );
}
